import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import TimelineEntry from './TimelineEntry';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: theme.spacing(2),
  },
}));

const ComplaintTimeline = ({ responses }) => {
  const classes = useStyles();

  if (!responses || responses.length === 0) {
    return (
      <List>
        <ListItem>
          <ListItemText
            secondary={
              <FormattedMessage id="complaints.noResponses" defaultMessage="No responses yet" />
            }
          />
        </ListItem>
      </List>
    );
  }

  const sorted = [...responses].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

  return (
    <div className={classes.wrapper}>
      {sorted.map((response) => (
        <TimelineEntry key={response.id} response={response} />
      ))}
    </div>
  );
};

ComplaintTimeline.propTypes = {
  responses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      action: PropTypes.string,
      created_at: PropTypes.string,
    }),
  ),
};

export default ComplaintTimeline;
